import React from 'react';
import { Typography } from '@material-ui/core';
import {
  primary,
  grey,
  danger,
} from './brand-colors';
import { daysRemaining } from './dateHelper';
import periods from './periods';

export const getNumberValue = (value) => {
  if (!Number.isNaN(Number(value))) {
    return Number(value).toLocaleString();
  }
  return value;
};

export const ANNUAL_STANDARD = 'annual-standard-plan';
export const MONTHLY_STANDARD = 'monthly-standard-plan';

export const getPlanForOtherFrequency = (currentPlan) => {
  switch (currentPlan) {
    case ANNUAL_STANDARD:
      return MONTHLY_STANDARD;
    case MONTHLY_STANDARD:
      return ANNUAL_STANDARD;
    default: {
      return null;
    }
  }
};

export const getPeriodForPerUserPlan = (stripePlan) => {
  switch (stripePlan) {
    case ANNUAL_STANDARD:
      return periods.year;
    case MONTHLY_STANDARD:
      return periods.month;
    default: {
      return null;
    }
  }
};

export const isAnnualPlan = (plan) => {
  switch (plan) {
    case ANNUAL_STANDARD:
      return true;
    default:
      return false;
  }
};

export const getBillingInformation = (tenant) => {
  const hasValidPaidPlan = !!tenant.stripeCardId && !!tenant.userLimit;
  const isOnFreeTrial = !!tenant.freeTrialEndDate && new Date(tenant.freeTrialEndDate).getTime() > new Date().getTime();
  let billingHeadline = (!hasValidPaidPlan && isOnFreeTrial)
    ? `Trial ends in ${daysRemaining(tenant.freeTrialEndDate)} days`
    : 'Free Trial Expired';
  let billingDescription = (!hasValidPaidPlan && isOnFreeTrial)
    ? 'Subscribe to a per user plan and add a payment method to continue using Pingum after the trial ends.'
    : 'Subscribe to a per user plan and add a payment method to continue using Pingum.';
  let billingIcon = (!hasValidPaidPlan && isOnFreeTrial)
    ? 'info'
    : 'unpublished';
  let billingColor = (!hasValidPaidPlan && isOnFreeTrial)
    ? grey.main
    : danger.main;

  if (hasValidPaidPlan) {
    billingHeadline = `${tenant.userLimit} Users, Paying ${isAnnualPlan(tenant.stripePlan)
      ? 'Annually'
      : 'Monthly'}`;
    billingDescription = 'You can change your subscription at any time. Any change during an active billing cycle will result in prorated credits on your account.';
    billingIcon = 'check';
    billingColor = primary.main;
  }

  return {
    userLimit: tenant.userLimit,
    stripePlan: tenant.stripePlan,
    trialDaysRemaining: isOnFreeTrial
      ? daysRemaining(tenant.freeTrialEndDate)
      : 'Free Trial Complete',
    hasValidPaidPlan,
    isOnFreeTrial,
    freeTrialEndDate: tenant.freeTrialEndDate,
    billingHeadline,
    billingDescription,
    billingIcon,
    billingColor,
  };
};

export const getBillingAmounts = (userLimit, selectedPeriod) => (
  <div>
    <Typography align="center" component="div">
      {userLimit} user{userLimit > 1 && 's'} at ${selectedPeriod.perUserMonthPrice} per user per month.
    </Typography>
    <Typography variant="caption" component="div" align="center" gutterBottom>
      ${selectedPeriod.label === periods.month.label
      ? `${selectedPeriod.perUserMonthPrice * userLimit} due each month.`
      : `${selectedPeriod.perUserMonthPrice * userLimit}
  each month, $${selectedPeriod.perUserMonthPrice * userLimit * 12} due annually`}
    </Typography>
  </div>
);
